import script from "./SpinFacade.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinFacade.vue?vue&type=script&setup=true&lang=js"

import "./SpinFacade.vue?vue&type=style&index=0&id=22abe7ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22abe7ff"]])

export default __exports__